import React, { useState, useEffect } from 'react'
import {
  Typography,
  Tooltip,
  IconButton
} from '@material-ui/core'
import { ReactComponent as SortIcon } from 'static/icons/sort.svg'
import { ReactComponent as MarkAsRead } from 'static/icons/mark-as-read.svg'
import { useDispatch, useSelector } from 'react-redux'
import { getCommonNotifications, setAllReadCommonNotifications } from 'utils/notifications/actions'
import CommonNotificationListItem from 'components/CommonNotificationListItem'
import useStyles from './styles'


const sorting = [
  'name',
  '-created',
]

const CommonNotificationsList = (props) => {
  const {
    search,
    setShowNotifications
  } = props
  const dispatch = useDispatch()
  const localClasses = useStyles()
  const activeWorkspacePk = useSelector(state => state.auth.activeWorkspacePk)
  const commonNotifications = useSelector(state => state.notifications.commonNotifications)
  const commonNotificationsNext = useSelector(state => state.notifications.commonNotificationsNext)
  const isLoadingCommonNotifications = useSelector(state => state.notifications.isLoadingCommonNotifications)
  const commonNotificationsUnreadCount = useSelector(state => state.notifications.commonNotificationsUnreadCount)
  const [sort, setSort] = useState(sorting[1])

  useEffect(() => {
    dispatch(getCommonNotifications(null, sort, search === '' ? null : search))
  }, [sort, search, activeWorkspacePk]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleSortChange = (sorting) => {
    if (sort.endsWith(sorting) && sort.startsWith('-')) {
      setSort(sort.substring(1))
    } else if (sort.endsWith(sorting)) {
      setSort('-' + sort)
    } else {
      setSort(sorting)
    }
  }

  const renderNotifications = () => {
    return commonNotifications.map((not, index) => (
      <CommonNotificationListItem
        key={not.id}
        setShowNotifications={setShowNotifications}
        {...not}
      />
    ))
  }

  const handleNotificationsScroll = (event) => {
    const { scrollTop, scrollHeight, offsetHeight } = event.currentTarget
    const shouldScroll = scrollHeight === scrollTop + offsetHeight
    if (shouldScroll && commonNotificationsNext  && !isLoadingCommonNotifications) {
      dispatch(getCommonNotifications(commonNotificationsNext))
    }
  }

  const handleMarkAllAsReadClick = (event) => {
    dispatch(setAllReadCommonNotifications())
  }

  return (
    <>
      <div className={localClasses.sortFilters}>
        <div className={localClasses.name}>
          <Typography
            variant='caption'
            className={sort.endsWith('name') ? localClasses.active : ''}
            onClick={() => handleSortChange('name')}
          >
            Title <SortIcon className={`${localClasses.sortIcon} ${sort === '-name' ? localClasses.revert : ''}`} />
          </Typography>
        </div>
        <div className={localClasses.created}>
          <Typography
            variant='caption'
            className={sort.endsWith('created') ? localClasses.active : ''}
            onClick={() => handleSortChange('created')}
          >
            Time <SortIcon className={`${localClasses.sortIcon} ${sort === '-created' ? localClasses.revert : ''}`} />
          </Typography>
        </div>
        <div className={localClasses.markAsReadSelected}>
          <Tooltip title='Mark all as read'>
            <span>
              <IconButton
                aria-controls='mark-all-as-read'
                className={localClasses.formControl}
                onClick={handleMarkAllAsReadClick}
                size='small'
                disabled={commonNotificationsUnreadCount <= 0}
                color='secondary'
              >
                <MarkAsRead
                  className={localClasses.readSelected}
                />
              </IconButton>
            </span>
          </Tooltip>
        </div>
      </div>
      <div
        className={localClasses.notificationsList}
        onScroll={handleNotificationsScroll}
      >
        {renderNotifications()}
      </div>
    </>
  )
}

export default CommonNotificationsList
